<template>
  <div class="login-conter-bg">
    <div class="login-bg">实名认证</div>
    <div v-if="!isCertified">
      <van-form>
        <van-field
          v-model="name"
          name="name"
          clearable
          label="真实姓名"
        />
        <van-field
          v-model="idCard"
          name="idCard"
          label="身份证号"
          clearable
        />
        <div style="margin: 16px">
          <van-button round block type="info" @click.prevent="goback">{{butName}}</van-button>
        </div>
      </van-form>

    </div>
    <div class="login-info-bg" v-if="isCertified">
      <div class="login-info">
        <van-cell-group :border="false">
          <van-field
            :border="false"
            :center="true"
            v-model="phone"
            placeholder="请输入手机号"
          />
          <van-field
            :border="false"
            :center="true"
            v-model="IDcard"
            placeholder="请输入身份证"
          />
          <van-field
            :border="false"
            :center="true"
            v-model="name"
            placeholder="请输入姓名"
          />
          <van-field
            maxlength="6"
            v-model="code"
            :center="true"
            clearable
            placeholder="请输入短信验证码"
          >
            <template #button>
              <div class="login-code-button" @click.prevent="sendCode">
                <svg-icon icon-class="login_code"></svg-icon>
                <p>{{ message }}</p>
              </div>
              <!-- <van-button size="small" type="primary" @click.prevent="sendCode">{{message}}</van-button> -->
            </template>
          </van-field>
        </van-cell-group>
      </div>
      <div class="login-button" @click.prevent="login">
        <svg-icon icon-class="login_button" />
        <p>登录</p>
      </div>
      <div class="login_bottom">
        <!-- <svg-icon icon-class="login_bottom" /> -->
        <van-checkbox
          v-model="checked"
          @click="onCkeck"
          :disabled="isDisabled"
          icon-size="15px"
          checked-color="#fc6e09"
          >已阅读知晓</van-checkbox
        >
        <p @click="checkProtocol">《平台服务使用协议》</p>
      </div>
    </div>
    <van-popup
      v-model="showProtocol"
      :closeable="true"
      position="bottom"
      :style="{ height: '100%' }"
    >
      <use-agreement @changeisTop="changeisTop"></use-agreement>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from "vant";
import URL from "@/api/api";
import { UrlSearch, setLocal } from "@/utils/utils";
import useAgreement from "./useAgreement.vue";
export default {
  components: { useAgreement },
  data() {
    return {
      phone: "",
      code: "",
      IDcard: "",
      idCard: '',
      butName: '',
      name: "",
      count: 0,
      timer: null,
      timer2: null,
      times: 0,
      message: "获取验证码",
      checked: false,
      showProtocol: false,
      isDisabled: true,
      isCertified:true,//是否认证
      pageFrom: ''
    };
  },
  mounted() {
    this.checkOpenid();
    this.checkUserId();
    this.selectuser();
    this.init();
  },
  methods: {
    onCkeck() {
      if (this.isDisabled) {
        Toast("请将协议阅读完整");
      }
    },
    checkUserId() {
      this.timer2 = setInterval(() => {
        if (this.times >= 0 && this.times <= 6) {
          if (localStorage.getItem("userid")) {
            this.selectuser()
            this.times = 99
          }
          console.log("=======>还未获取到userId" + this.times)
          this.times ++
        } else {
          clearInterval(this.timer2)
          this.timer2 = null
        }
      }, 1000)
    },
    selectuser() {
      let that=this
      that.$fetchPost(URL.getuserdetail1.url, { id: localStorage.getItem("userid"), channel: "ZFKJ" }).then(res => {
        if (res.data.code === 20000 && res.data.data.idNo && res.data.data.realName) {
          that.name = res.data.data.realName;
          that.idCard = res.data.data.idNo;
          that.isDisabled = true
          that.butName='已认证'
          that.isCertified=false
        }
      })
    },
    changeisTop() {
      this.isDisabled = false;
    },
    login() {
      setLocal("phone", this.phone);
      let data = {
        phoneNo: this.phone,
        verifyCode: this.code,
        name: this.name,
        id_card: this.IDcard,
        openid: localStorage.getItem("openid"),
        channel: 'ZFKJ'
      };
      let phoneNo = /^1[3456789]\d{9}$/;
      if (this.phone == "") {
        Toast("请输入手机号");
      } else if (!phoneNo.test(this.phone)) {
        Toast("手机号格式不正确");
      } else if (this.name == "") {
        Toast("请输入姓名");
      } else if (this.IDcard == "") {
        Toast("请输入身份证号");
      } else if (this.code == "") {
        Toast("请输入短信验证码");
      } else if (!this.checked) {
        Toast("请勾选下方协议");
      } else {
        this.$fetchPost(URL.sassLogin.url, data).then((res) => {
          if (res.data.code === 20000) {
            setLocal("isLogin", "1");
            Toast('认证成功');
            if (this.pageFrom === 'focus') {
              // 如果是关注公众号跳转过来的，则认证成功之后跳转到首页，其他则后退
              this.$router.push('/')
            } else {
              this.$router.go(-1);
            }
          } else {
            Toast(res.data.msg);
          }
        });
      }
    },
    init() {
      let no = UrlSearch().no;
      if (no) {
        this.pageFrom = no
      }
    },
    sendCode() {
      let data = {
        type: 5,
        phoneNumber: this.phone,
      };
      let phoneNo = /^1[3456789]\d{9}$/;
      if (!phoneNo.test(this.phone)) {
        Toast("请输入正确手机号");
      } else {
        this.$fetchGet(URL.sassSend.url, data).then((res) => {
          if (res.data.code === 20000) {
            if (!this.timer) {
              this.count = 60;
              this.timer = setInterval(() => {
                if (this.count >= 0 && this.count <= 60) {
                  this.message = this.count-- + " " + "s";
                } else {
                  this.message = "获取";
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          } else {
            Toast(res.data.msg);
          }
        });
      }
    },
    checkProtocol() {
      this.showProtocol = true;
    },
    getUrlParams: function (paramsName) {
      const url = window.location.href; //当前页面的地址
      const reg = /([^?&=]+)=([^?&=]+)/g,
        obj = {};
      url.replace(reg, function () {
        obj[arguments[1]] = arguments[2];
      });
      for (let keyName in obj) {
        if (keyName === paramsName) {
          return obj[keyName];
        }
      }
    },
    getOpenid() {
      window.location.replace(
        "https://dtfcloud.com/gateway-api/center/zhifu/userinfo"
      );
    },
    goback() {
      if (this.pageFrom === 'focus') {
        // 如果是关注公众号跳转过来的，则认证成功之后跳转到首页，其他则后退
        this.$router.push('/')
      } else {
        this.$router.go(-1);
      }
    },
    checkOpenid() {
      //判断是否登录
      let openid = localStorage.getItem("openid");
      if(!openid){
        openid=UrlSearch().openid;
      }
      // if (openid) {
      //   localStorage.setItem("openid", openid);
      //   this.$fetchPost(URL.checkOpenid.url + openid).then((res) => {
      //     console.log(res);
      //     if (res.data.code === 20000) {
      //       this.ket = 1;
      //       setLocal("isLogin", 1);
      //       setLocal("phone", res.data.data.phoneNo);
      //       setLocal("authFlag", res.data.data.authFlag);
      //       if (res.data.data.phoneNo && res.data.data.authFlag == "1") {
      //         this.$router.replace("/tobePaid");
      //       }
      //     }
      //   });
      // } else {
      //   this.getOpenid();
      // }
    },
  },
};
</script>

<style lang="less" scoped>
.login-conter-bg {
  height: 100vh;
  background: #fff;
  overflow: scroll;
}
.login-bg {
  width: 375px;
  height: 90px;
  text-align: center;
  background: url("./img/login-top.png") no-repeat 100%;
  background-size: 100% 100%;
  text-align: center;
  line-height: 80px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
}
.login-info-bg {
  width: 375px;
  height: calc(100vh - 80px);
  margin-top: -17.5px;
  background: #ffffff;
  border-radius: 10px 10px 0 0;
}
.login-info {
  width: 320px;
  margin: auto;
  overflow: hidden;
  .van-cell {
    height: 46px;
    background: transparent;
    border-bottom: 1px solid #ededed;
    margin-top: 38px;
    padding: 10px 0 18px 0;
    /deep/.van-field__left-icon {
      margin-right: 18px;
    }
  }
  .svg-icon {
    width: 20.8px;
    height: 30.13px;
  }
  .login-code-button {
    position: relative;
    width: 1.94667rem;
    height: 0.74667rem;
    .svg-icon {
      width: 73px;
      height: 28px;
      background-position: center;
    }
    p {
      width: 100%;
      text-align: center;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      font-size: 12px;
      font-weight: Regular;
      font-family: PingFang SC;
      color: #fc6e09;
    }
  }
}
.login-button {
  width: 272.5px;
  height: 42px;
  margin: 65px auto 0 auto;
  position: relative;
  .svg-icon {
    height: 42px;
  }
  p {
    width: 272.5px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
    font-size: 15px;
    color: #ffffff;
  }
}
.login_bottom {
  height: 15.5px;
  line-height: 15.5px;
  display: flex;
  justify-content: center;
  font-size: 12px;
  margin: 100px auto 20px auto;
  /deep/.van-checkbox__icon {
    height: 15.5px;
    line-height: 15.5px;
  }
  p {
    color: #fc6f0c;
  }
}
</style>